import { SourceSansBold } from './SourceSansPro-Bold';
import { SourceSansSemiBold } from './SourceSansPro-Semibold';
import { SourceSansRegular } from './SourceSansPro-Regular';

export const SourceSansPro = `
    ${SourceSansBold}
    ${SourceSansSemiBold}
    ${SourceSansRegular}
`;
